/** Azure built-in role definitions P0 recommends as defaults for SSH/RDP VM
 * access. These are Microsoft-managed roles whose GUIDs are stable across every
 * tenant, so a customer can reference them without creating a custom role. */
export const VIRTUAL_MACHINE_ADMINISTRATOR_LOGIN_ROLE = {
  name: "Virtual Machine Administrator Login",
  id: "1c0163c0-47e6-4577-8991-ea5c82e286e4",
} as const;

export const VIRTUAL_MACHINE_USER_LOGIN_ROLE = {
  name: "Virtual Machine User Login",
  id: "fb879df8-f326-4884-b1cf-06f3ad86be52",
} as const;
